import { EventBus } from '@primeuix/utils/eventbus';

var PrimeVueService = EventBus();

export { PrimeVueService as default };
//# sourceMappingURL=index.mjs.map
